import { Box, Grid } from '@mui/material';

import { SettingsHeader } from '../../components/SettingsHeader';
import { WsBreadCrumbs } from '../../components/WsBreadCrumbs';
import {
  getSettingBreadCrumbList,
  ISettingBreadCrumbTypes,
  Pages,
} from '../teams/helper/defaultValues';

import EmailTemplateSettings from './components/EmailTemplateSettings';
import ExcelTemplateSettings from './components/ExcelTemplateSettings';
import JobsTemplateSettings from './components/JobsTemplateSettings';
import SubmissionTemplateSettings from './components/SubmissionTemplateSettings';
import TemplateSettingsSideIndex from './components/TemplateSettingsSideIndex';

interface ITemplateSettingsProps {
  type: string;
}

const TemplateSettings = ({ type }: ITemplateSettingsProps) => (
  <Box>
    <WsBreadCrumbs
      breadCrumbsList={getSettingBreadCrumbList(
        ISettingBreadCrumbTypes.APPS_AND_INTEGRATION,
        Pages['TEMPLATE_SETTINGS']
      )}
    />
    <SettingsHeader title="Template Settings" />
    <Grid container spacing={1}>
      <Grid item xs={2.5} marginTop={2} pl={0} borderRadius={1.5}>
        <TemplateSettingsSideIndex />
      </Grid>
      <Grid marginTop={2} item xs={9.5}>
        {type == 'email' && <EmailTemplateSettings />}
        {type == 'submission' && <SubmissionTemplateSettings />}
        {type == 'excel' && <ExcelTemplateSettings />}
        {type == 'jobs' && <JobsTemplateSettings />}
      </Grid>
    </Grid>
  </Box>
);
export default TemplateSettings;
